/* global fetch:false */
import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import injectSheet from 'react-jss';
import cn from 'classnames';
import { connect } from 'react-redux';
import { colourThemeType } from '../../propTypes';
import theme, { sliceColourTheme } from '../../styles/theme';
import { getSliceContent, getEveApiUrl } from '../../selectors';
import Competition from './Competition';
import ResponsiveImage from '../ResponsiveImage';

class CompetitionBanner extends React.Component {
  state = {
    success: false,
    error: false,
  };

  handleSubmit = async payload => {
    // eslint-disable-next-line react/prop-types
    const { eveApiUrl } = this.props;

    const apiUrl = `${eveApiUrl}/customer/newsletter`;

    const options = {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    };
    try {
      const response = await fetch(apiUrl, options);
      if (response.ok) {
        this.setState({ success: true });
      } else {
        this.setState({ error: true });
      }
    } catch (error) {
      this.setState({ error: true });
    }
  };

  render() {
    const {
      backgroundImage,
      classes,
      colourTheme,
      imageAlignment,
      sliceId,
    } = this.props;

    const { success, error } = this.state;

    return (
      <div className={cn(classes.flex, classes.text, {
        [classes.alignRight]: imageAlignment === 'right',
      })}
      >
        <ResponsiveImage
          aspect={backgroundImage.aspect}
          images={backgroundImage.sizes}
          blur={backgroundImage.blur}
          className={cn(classes.backgroundImage, classes.flexChild)}
        />

        <Competition
          error={error}
          success={success}
          onSubmit={this.handleSubmit}
          sliceId={sliceId}
          colourTheme={colourTheme}
        />
      </div>
    );
  }
}

export const defaultColourTheme = sliceColourTheme.white;

CompetitionBanner.defaultProps = {
  backgroundImage: PropTypes.shape({
    blur: {},
    sizes: [],
    aspect: '',
  }),
  colourTheme: defaultColourTheme,
};

CompetitionBanner.propTypes = {
  backgroundImage: PropTypes.shape({
    blur: PropTypes.object,
    sizes: PropTypes.array,
    aspect: PropTypes.number,
  }),
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  colourTheme: colourThemeType,
  imageAlignment: PropTypes.oneOf(['left', 'right']).isRequired,
  sliceId: PropTypes.number.isRequired,
};

const mapStateToProps = (state, { sliceId }) => ({
  backgroundImage: getSliceContent(state, sliceId).image,
  imageAlignment: getSliceContent(state, sliceId).image_alignment,
  colourTheme: sliceColourTheme[getSliceContent(state, sliceId).colour_theme],
  eveApiUrl: getEveApiUrl(state),
});

export default compose(
  connect(mapStateToProps),
  injectSheet({
    flex: {
      display: 'flex',
      margin: '20px 0',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    flexChild: {
      flex: 1,
      flexBasis: '50%',
      position: 'relative',
    },
    text: {
      color: ({ colourTheme }) => colourTheme.textColour,
    },
    alignRight: {
      flexDirection: 'row-reverse',
      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },
    },
    backgroundImage: {
      [theme.breakpoints.down('md')]: {
        flex: 'none',
        display: 'block',
        height: 400,
      },
    },
  }),
)(CompetitionBanner);
